import { Util, devLog } from "Util";
import { FetchManager, HOST } from "config";
import { create } from "zustand";

export interface LoginFormType {
  loginId: String;
  password: String;
}

export interface AuthStoreType {
  verifyUserLogin: (formData: LoginFormType) => Promise<any>;
  getUserInfo: () => Promise<any>;
  userLogout: () => Promise<any>;
}

const useAuthAPIStore = create<AuthStoreType>((set) => ({
  async verifyUserLogin(formData: LoginFormType) {
    try {
      const url = `${HOST}/user/login`;
      const res = await FetchManager.post(url, formData);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog("[verifyUserLogin] 오류 발생", e);
      return false;
    }
  },
  async getUserInfo() {
    try {
      const url = `${HOST}/user/loginInfo`;
      const res = await FetchManager.get(url);
      const data = await Util.fetchAndSetData(res);
      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog("[getUserInfo] 오류 발생", e);
      return false;
    }
  },
  async userLogout() {
    try {
      const url = `${HOST}/user/logout`;
      const res = await FetchManager.post(url);
      const data = await Util.fetchAndSetData(res);
      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog("[userLogout] 오류 발생", e);
      return false;
    }
  },
}));

export default useAuthAPIStore;
